import { jsx as _jsx } from "react/jsx-runtime";
import { Modal as HeroModal, ModalContent as HeroModalContent, ModalHeader as HeroModalHeader, ModalBody as HeroModalBody, ModalFooter as HeroModalFooter, useDisclosure } from '@heroui/react';
export const Modal = (props) => {
    return _jsx(HeroModal, { ...props });
};
export const ModalContent = (props) => {
    return _jsx(HeroModalContent, { ...props });
};
export const ModalHeader = (props) => {
    return _jsx(HeroModalHeader, { ...props });
};
export const ModalBody = (props) => {
    return _jsx(HeroModalBody, { ...props });
};
export const ModalFooter = (props) => {
    return _jsx(HeroModalFooter, { ...props });
};
export { useDisclosure };
export default Modal;
//# sourceMappingURL=Modal.js.map